/* Serevue cart drawer. No dependencies.
   The drawer's markup lives in sections/sv-cart-drawer.liquid and is refreshed
   through Shopify's Section Rendering API, so cart lines are written in exactly
   one place. */
(function () {
  'use strict';

  var SECTION = 'sv-cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function drawer() { return $('[data-sv-cart-drawer]'); }
  function overlay() { return $('[data-sv-cart-overlay]'); }

  var lastFocus;

  function focusables() {
    var d = drawer();
    if (!d) return [];
    return $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', d);
  }

  function open() {
    var d = drawer(), o = overlay();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (o) o.classList.add('is-open');
    document.body.classList.add('sv-lock');
    var close = $('[data-sv-cart-close]', d);
    if (close) close.focus();
    watchWallets();
  }

  function close() {
    var d = drawer(), o = overlay();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (o) o.classList.remove('is-open');
    document.body.classList.remove('sv-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  function isOpen() {
    var d = drawer();
    return !!d && d.classList.contains('is-open');
  }

  /* Pull a freshly rendered drawer and swap its contents, keeping the outer
     element so the open state and any running transition survive. */
  function refresh() {
    // Rendered from the page we are on, so the drawer's own copy of the wallet
    // buttons stays suppressed on the cart page, where the summary renders them.
    //
    // No Accept: application/json header here, deliberately. With it, Shopify
    // answers /products/<handle> with the PRODUCT json and /cart with the CART
    // json, ignoring ?sections= entirely — the response comes back 200 with no
    // section in it, so the drawer silently kept whatever it was last given.
    // That is why it stayed empty after adding from the product page. Only the
    // home page, which has no resource json of its own, was unaffected.
    return fetch(window.location.pathname + '?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-sv-cart-drawer]');
        var current = drawer();
        if (!fresh || !current) return;
        current.innerHTML = fresh.innerHTML;
        watchWallets();
      })
      .catch(function () { /* leave the drawer as it stands rather than blanking it */ });
  }

  /* Header count, kept in step without depending on sv-theme.js load order. */
  function syncCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-sv-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  /* Apple Pay and Google Pay are both device wallets, and Shopify renders both
     wherever the browser supports both — iOS Safari was showing the pair, one
     under the other. Keep one: Apple Pay where it is genuinely offered, since
     that is the wallet those customers already have set up, and Google Pay
     everywhere else (on Android and in Chrome no Apple Pay button is rendered
     at all, so nothing is suppressed).

     Tested by rendered height rather than mere presence, so a button that
     exists in the markup but cannot actually be used never suppresses the one
     that can. Runs before the spacing pass below, which then closes the gap
     the hidden button leaves behind. */
  function pickDeviceWallet(holder) {
    var apple = holder.querySelector('shopify-apple-pay-button, [slot="button-ApplePay"]');
    var google = holder.querySelector('shopify-google-pay-button, [slot="button-GooglePay"]');
    if (!apple || !google) return;
    if (!apple.offsetHeight) return;
    google.style.setProperty('display', 'none', 'important');
  }

  /* Shopify renders each enabled wallet into a fixed slot inside the accelerated
     checkout component's CLOSED shadow root. Hiding one from the light DOM removes
     the button but not its slot, so the buttons we keep end up spaced apart. A
     slotted element's own margin does still apply, so pull each visible button up
     over whatever was hidden above it. Cosmetic only — which payment methods exist
     is a Shopify setting, untouched here. Measured rather than hard-coded so it
     stays correct if the shop's wallet set changes. */
  function tidyWallets() {
    $$('.sv-express--trim shopify-accelerated-checkout-cart').forEach(function (holder) {
      pickDeviceWallet(holder);
      var step = 0;
      var hiddenAbove = 0;
      Array.prototype.slice.call(holder.children).forEach(function (wallet) {
        if (window.getComputedStyle(wallet).display === 'none') { hiddenAbove += 1; return; }
        if (!step) step = wallet.offsetHeight + 8; // button height plus the row gap set in CSS
        if (hiddenAbove) {
          wallet.style.setProperty('margin-top', -(hiddenAbove * step) + 'px', 'important');
        } else {
          wallet.style.removeProperty('margin-top');
        }
        hiddenAbove = 0;
      });
    });
  }

  /* The component renders asynchronously and re-renders on cart changes. */
  function watchWallets() {
    [120, 500, 1200, 2500].forEach(function (ms) { window.setTimeout(tidyWallets, ms); });
    if (!window.MutationObserver) return;
    $$('.sv-express--trim').forEach(function (wrap) {
      if (wrap.dataset.svWalletsBound) return;
      wrap.dataset.svWalletsBound = '1';
      new MutationObserver(function () { window.setTimeout(tidyWallets, 60); })
        .observe(wrap, { childList: true, subtree: true });
    });
  }

  function setLineBusy(line, busy) {
    var el = $('[data-sv-cart-line="' + line + '"]');
    if (el) el.classList.toggle('is-busy', !!busy);
  }

  function changeLine(line, quantity) {
    setLineBusy(line, true);
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return Promise.all([refresh(), syncCount()]); })
      .catch(function () { setLineBusy(line, false); });
  }

  /* Shopify applies codes through its own /discount/ route; there is no
     supported AJAX endpoint for it, so this hands off and comes back to the cart. */
  function applyDiscount(input) {
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-sv-cart-open]');
    if (openBtn) {
      if (!drawer()) return; // no drawer on this layout — let the link through
      e.preventDefault();
      open();
      refresh();
      return;
    }

    if (e.target.closest('[data-sv-cart-close]') || e.target.closest('[data-sv-cart-overlay]')) {
      e.preventDefault();
      close();
      return;
    }

    var step = e.target.closest('[data-sv-cart-qty]');
    if (step) {
      var line = step.getAttribute('data-sv-cart-qty');
      var input = $('[data-sv-cart-input="' + line + '"]');
      var next = (parseInt(input && input.value, 10) || 0) + parseInt(step.getAttribute('data-sv-delta'), 10);
      changeLine(line, Math.max(0, next));
      return;
    }

    var remove = e.target.closest('[data-sv-cart-remove]');
    if (remove) {
      changeLine(remove.getAttribute('data-sv-cart-remove'), 0);
      return;
    }

    var apply = e.target.closest('[data-sv-discount-apply]');
    if (apply) {
      e.preventDefault();
      applyDiscount($('input[name="code"]', apply.closest('[data-sv-discount-form]')));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-sv-cart-input]');
    if (!input) return;
    changeLine(input.getAttribute('data-sv-cart-input'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-sv-discount-form]');
    if (!form) return;
    e.preventDefault();
    applyDiscount($('input[name="code"]', form));
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* sv-theme.js fires this after a successful add to cart. */
  document.addEventListener('sv:cart:added', function () {
    open();
    refresh();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === SECTION) refresh();
    watchWallets();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchWallets);
  else watchWallets();
})();
